export const environment = {
  production: false,
  redirectOnError: true,
  apiBaseUrl: 'https://api-store.boostaging.com/api',
  authNetEditPaymentUrl: 'https://test.authorize.net/customer/editPayment',
  authNetAddPaymentUrl: 'https://test.authorize.net/customer/addPayment',
  authNetIframeCommunicator: 'https://store.boostaging.com/assets/auth-net/iFrameCommunicator.html'
};
